import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  requestFailed: {
    id: 'studio.80/PNO',
    defaultMessage:
      'This verification link is incomplete, invalid, or has already been used. If you have already verified your email address, you can log in. Otherwise, log in and request a new verification email.',
  },
  requestSuccess: {
    id: 'studio.fbMdX+',
    defaultMessage:
      'Your email was successfully verified! \nHave fun exploring Appsemble. Redirecting in 3 seconds.',
  },
});
